import { Skeleton, Switch } from "antd";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { NotificationSettingApi } from "../../../api/request/settings/settings";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";

const Notification = ({ isLoading, settingsData, setSettingsData }) => {
  const [type, setType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoadingNotification, setIsLoadingNotification] = useState(false);

  const notificationHandler = async () => {
    try {
      setIsLoadingNotification(true);
      const params =
        type === "notifications"
          ? { is_notify: !settingsData?.is_notify }
          : { is_email_send: !settingsData?.is_email_send };
      const { data } = await NotificationSettingApi(params);

      if (data?.status) {
        type === "notifications"
          ? (settingsData.is_notify = !settingsData?.is_notify)
          : (settingsData.is_email_send = !settingsData?.is_email_send);
        setSettingsData(settingsData);
        toast.success(data?.message);
        setIsModalOpen(false);
      }
      setIsLoadingNotification(false);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsLoadingNotification(false);
    }
  };
  return (
    <div>
      <div className="border rounded-lg p-4">
        <p className="title border-b pb-3">Notification</p>
        {isLoading ? (
          <div className="flex items-center gap-4 mt-5">
            <Skeleton.Button active={true} size="small" />
            <Skeleton.Button active={true} size="small" block={true} />
          </div>
        ) : (
          <>
            <div className="flex items-center gap-4 mt-5">
              <Switch
                onClick={() => {
                  setType("notifications");
                  setIsModalOpen(true);
                }}
                value={settingsData?.is_notify}
              />
              <p>Receive in-app notifications.</p>
            </div>
            <div className="flex items-center gap-4 mt-5">
              <Switch
                onClick={() => {
                  setType("emails");
                  setIsModalOpen(true);
                }}
                value={settingsData?.is_email_send}
              />
              <p>Receive updates via email.</p>
            </div>
          </>
        )}
      </div>

      {/* -------- Disable notification modal -------- */}
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message={`Are you sure you want to ${
          settingsData?.is_notify ? "disable" : "enable"
        } ${type}?`}
        onConfirm={notificationHandler}
        isLoading={isLoadingNotification}
        loadingLabel={`${
          settingsData?.is_notify ? "Disabling" : "Enabling"
        }...`}
      />
    </div>
  );
};

export default Notification;
